import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import {loadjs} from './assets/libs/loadjs';
import {setAxiosToken} from './assets/libs/diy-axios'
// 20191116安装懒加载
import VueLazyload from 'vue-lazyload'

// xj add start
// 引入axios
import axios from 'axios'
import qs from 'qs'
// 引入重置样式
import '@/assets/css/reset.css'
// 引入自定义样式
import '@/assets/css/xjpublic.css'
// 全局引入组件
import { Button, Dialog, Toast, Notify, Icon, NavBar, Row, Col, Loading, ActionSheet } from 'vant'
Vue.use(Button).use(Dialog).use(Toast).use(Notify).use(Icon).use(NavBar).use(Row).use(Col).use(Loading).use(ActionSheet);
// cookies
Vue.use(VueCookies);
// axios的配置和使用
axios.defaults.timeout = 15000;
// 测试环境&正式环境
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL || '//api-dev.spreadwin.cn';
// axios.defaults.baseURL = process.env.VUE_APP_BASE_URL || 'http://api.spreadwin.cn';
// 测试环境
// axios.defaults.baseURL = 'http://api-dev.spreadwin.cn';
// 正式环境
// axios.defaults.baseURL = 'http://api.spreadwin.cn';

// axios.defaults.crossDomain = true;
// axios.defaults.withCredentials = true;

// axios.defaults.baseURL = 'http://127.0.0.1:4000';
axios.defaults.headers['Content-Type'] = 'application/json';
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
// 设置axios的返回拦截（还可以设置request拦截，这里暂时不用）
// axios.interceptors.response.use(
//   response => {
//     return response;
//   },
//   error => {
//     // 判断是否是网络错误
//     if (error.message.includes('Network')) {
//       console.log('网络错误，请检查网络');
//       // reject这个错误信息
//       return Promise.reject(error);
//     }
//     // 判断请求异常信息中是否含有超时timeout字符串
//     if(error.message.includes('timeout')){
//       console.log('错误回调', error);
//       // reject这个错误信息
//       return Promise.reject(error);
//     }
//     return Promise.reject(error);
//   }
// );
const $cookies = Vue.prototype.$cookies;
const cookieTk = $cookies.get('tk');
setAxiosToken(cookieTk, $cookies.get('customer'));//this.$store.state.token
store.state.token = cookieTk;
store.state.customer = $cookies.get('customer');
store.state.nowImei = $cookies.get('imei');
store.state.openid = $cookies.get('openid');

// 动态设置页面标题
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
});
// 重新定义一个跳转页面的方法：rawPush(原生跳转方法),20190907
// 目的是解决水果系统分享页面时只有域名部分(首页),暂时不用该方法,因为会造成跳转缓慢(一般多页面跳转才用该方法)
router.rawPush = function (url) {
  window.location.href = url;
};
Vue.config.ignoredElements = [
  'wx-open-launch-weapp',
];
// 20191116 懒加载
Vue.use(VueLazyload);
// or with options
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   error: 'src/assets/images/img_default01.png',
//   loading: 'src/assets/images/ic_no_data.png',
//   attempt: 1
// });

// xj add end

Vue.config.productionTip = false;


const vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$once('document_ready', function (_vue){
  // console.log(_vue.constructor.prototype.$on.toString());
  _vue.$mount('#app');
});

// const vue = new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app');

loadjs( vue, store );
